import styled from 'styled-components';
import { onSurfaceVariant, primary, radiusFull, surfaceHigh } from '../themeTokens';
import { CHROME_INSET_PX } from './chrome.constants';

export const BottomSlot = styled.div`
  position: absolute;
  bottom: ${CHROME_INSET_PX}px;
  left: 50%;
  translate: -50% 0;
  z-index: 2;
  max-width: calc(100% - ${CHROME_INSET_PX * 2}px);
  pointer-events: auto;
`;

export const LightGroup = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

export const Swatch = styled.button<{ $color: string; $narrow: boolean }>`
  display: inline-grid;
  place-items: center;
  width: ${(p) => (p.$narrow ? 26 : 32)}px;
  height: ${(p) => (p.$narrow ? 26 : 32)}px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;

  &::after {
    content: '';
    width: ${(p) => (p.$narrow ? 18 : 22)}px;
    height: ${(p) => (p.$narrow ? 18 : 22)}px;
    border-radius: 50%;
    background: ${(p) => p.$color};
    box-shadow: 0 0 0 2px ${onSurfaceVariant};
  }

  &:hover {
    background: ${surfaceHigh};
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 1px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const Notice = styled.p`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  translate: -50% 0;
  margin: 0;
  padding: 6px 12px;
  border-radius: ${radiusFull};
  background: ${surfaceHigh};
  color: ${onSurfaceVariant};
  font-size: 12px;
  white-space: nowrap;
`;
